/**
 **@disc: 设备信息变更工单常量
 **@author: mengln
 */
export const DeviceInfoEditConstant = {
  TICKET: 'DeviceInfoEdit'
};

/**
 * 设备操作 现场支持 系统操作类工单templateCode
 */
export const ServiceSupport = [
  'DeviceView',
  'NetworkMaint',
  'PeripheralAccess',
  'IPConfig',
  'OtherService',
  'RemoteConnection',
  'DeviceShutDown',
  'DeviceBoot',
  'ResetBMC',
  'SystemReinstall',
  'DeviceReboot',
  'DeviceNetoff',
  'DevicePoweroff',
  'CabinetView',
  'ReplacementChange',
  'VerifyWiringDistance'
];

/**
 * 设备操作 现场支持 系统操作类工单templateCode
 */
export const DEVICE_ASSETBELONG = {
  OWN: 1 // 客户自备设备
};
export const OrderTypeConstant = {
  1: 'NEW', /* 新购 */
  2: 'RESIZE_FORMULA', /* 变配 */
};

export const ChargeModeConstant = {
  1: 'CONFIG', // 按配置
  2: 'FLOW', // 按用量
  3: 'MONTHLY', // 包年包月
  4: 'ONCE', // 按次付费
}

export const ChargeUnitConstant = {
  1: 'HOUR', // 小时
  2: 'DAY', // 天
  3: 'MONTH', // 月
  4: 'YEAR', // 年
}

/**
 **@disc: ServiceCodeConstant
 */
export const ServiceCodeConstant = {
  'CCS': 'jdccs'
};


/**
 **@disc: regionConstant
 */
export const RegionConstant = {
  'stag': 'cn-north-1',
  'other': 'cn-north-1',
};



// WEBPACK FOOTER //
// ./src/common/Constants.js